import { useState } from 'react';

import { useDeleteVoucherMutation } from '../../../../transactions/hooks/useDeleteVoucherMutation';
import { useVouchersQuery } from '../../../../transactions/hooks/useVouchersQuery';

export const useVouchersDrawer = (eventId: string | null) => {
  const [voucherToDeleteId, setVoucherToDeleteId] = useState<string | null>(
    null,
  );
  const [isCreateVoucherDrawerOpen, setIsCreateVoucherDrawerOpen] =
    useState<boolean>(false);
  const { data, loading } = useVouchersQuery(eventId);

  const onShowDeleteDialog = (voucherId: string) => {
    setVoucherToDeleteId(voucherId);
  };
  const onCloseDeleteDialog = () => {
    setVoucherToDeleteId(null);
  };

  const { deleteVoucher } = useDeleteVoucherMutation(onCloseDeleteDialog);

  const onCreateVoucher = () => {
    setIsCreateVoucherDrawerOpen(true);
  };

  const onCreateVoucherDrawerClose = () => {
    setIsCreateVoucherDrawerOpen(false);
  };

  const onDeleteVoucher = () => {
    if (voucherToDeleteId) {
      deleteVoucher(voucherToDeleteId);
    }
  };

  const vouchers = data?.vouchers ?? [];
  return {
    vouchers,
    isCreateVoucherDrawerOpen,
    onCreateVoucher,
    onCreateVoucherDrawerClose,
    loading,
    onShowDeleteDialog,
    onDeleteVoucher,
    onCloseDeleteDialog,
    voucherToDeleteId,
  };
};
